export default __webpack_public_path__ + "static/media/icLight.a6ee86c1.svg";